{
  "CSAT": {
    "TITLE": "Bedøm din samtale",
    "PLACEHOLDER": "Fortæl os mere...",
    "RATINGS": {
      "POOR": "😞 Dårlig",
      "FAIR": "😑 Rimelig",
      "AVERAGE": "😐 Gennemsnitlig",
      "GOOD": "😀 God",
      "EXCELLENT": "😍 Fremragende"
    }
  }
}
